import { c as _c } from "react/compiler-runtime";
import type { PlayInfo } from '@module/apis/client-side/live/type';
import SettingConfig from '@module/config/setting';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import { useFetchFanListQuery } from '@module/queries/fan/fanQueryHooks';
import type { FanLevel } from '@module/types/centrifuge/publicMessageTypes';
import masking from '@module/utils/masking';
import BaseLottie from '@pc/components/lottie/BaseLottie';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { useState } from 'react';
import ChatGradePrefixImage from '../_components/ChatGradePrefixImage';
import ViewerInteractionMenu from '../_components/ViewerInteractionMenu';
interface Props {
  isRoomMaster: boolean;
  isManager: boolean;
  playInfo: PlayInfo | undefined;
}
function ViewerRankListContainer(t0) {
  const $ = _c(15);
  const {
    playInfo,
    isManager,
    isRoomMaster
  } = t0;
  const {
    isLogin,
    userInfo
  } = useGetLoginInfoQuery();
  const [menuVisibleOffset, setMenuVisibleOffset] = useState(0);
  const t1 = playInfo ? playInfo?.media.userIdx : userInfo?.idx || 0;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      limit: 50,
      offset: 0,
      userIdx: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: fanListQuery
  } = useFetchFanListQuery(t2);
  let t3;
  if ($[2] !== fanListQuery?.list?.length) {
    t3 = fanListQuery?.list?.length === 0 && <NotFoundDisplay text={"\uC5F4\uD608\uD32C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."} />;
    $[2] = fanListQuery?.list?.length;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== fanListQuery?.list || $[5] !== isLogin || $[6] !== isManager || $[7] !== isRoomMaster || $[8] !== menuVisibleOffset || $[9] !== playInfo || $[10] !== userInfo?.idx) {
    t4 = fanListQuery?.list?.map((item, idx) => <div key={item.userIdx} className="text-baseFg"><div className="relative flex w-full cursor-pointer items-center py-2 text-[14px] [&>*]:mr-2" onClick={() => {
        if (item.userIdx === userInfo?.idx) {
          return;
        }
        setMenuVisibleOffset(item.userIdx);
      }}>{idx === 0 && <BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/rank/1_last.json`} loop={true} className="h-[24px] w-[24px] shrink-0 text-center" />}{idx === 1 && <BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/rank/2_last.json`} loop={true} className="h-[24px] w-[24px] shrink-0 text-center" />}{idx === 2 && <BaseLottie src={`${SettingConfig.S3_BUCKET_URL}/json/lottie/rank/3_last.json`} loop={true} className="h-[24px] w-[24px] shrink-0 text-center" />}{idx > 2 && <div className="w-[24px] shrink-0 text-center font-nanum-square text-colorFg01">{idx + 1}</div>}<div className="shrink-0"><ChatGradePrefixImage ranking={item.rank} level={item.fanLevel as FanLevel} className=" h-[14px] w-[14px]" /></div><div className="ml-1 truncate">{item.userNick}({masking(item.userId)})</div>{isLogin && <ViewerInteractionMenu playInfo={playInfo} isVisible={!!menuVisibleOffset && item.userIdx === menuVisibleOffset} user={{
          isManager,
          isRoomMaster
        }} viewer={{
          idx: item.userIdx,
          id: item.userId,
          nick: item.userNick
        }} variant="fanRank" onClose={() => setMenuVisibleOffset(0)} showUserId={false} />}</div></div>);
    $[4] = fanListQuery?.list;
    $[5] = isLogin;
    $[6] = isManager;
    $[7] = isRoomMaster;
    $[8] = menuVisibleOffset;
    $[9] = playInfo;
    $[10] = userInfo?.idx;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <div className="scrollbar-custom h-full overflow-y-auto border-l px-2 py-[10px]">{t3}{t4}</div>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}
export default ViewerRankListContainer;